/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_BidInputs */

const en_common_auth_gate_action_bid = /** @type {(inputs: Common_Auth_Gate_Action_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`place your bid`)
};

const zh_common_auth_gate_action_bid = /** @type {(inputs: Common_Auth_Gate_Action_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参与出价`)
};

/**
* | output |
* | --- |
* | "place your bid" |
*
* @param {Common_Auth_Gate_Action_BidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_bid = /** @type {((inputs?: Common_Auth_Gate_Action_BidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_BidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_bid(inputs)
	return zh_common_auth_gate_action_bid(inputs)
});
export { common_auth_gate_action_bid as "common.auth.gate.action.bid" }